import React, { useEffect } from 'react';
import '.././App.css';
import { auth } from '../firebase';

function Header() {
  const signOut = () => {
    auth.signOut();
    window.location.href = "/login";
  };

  useEffect(() => {
    auth.onAuthStateChanged((user) => {});
  }, []);

  return (
    <div>
      <nav
        className="main-header navbar navbar-expand navbar-orange navbar-light"
        style={{
          background: "linear-gradient(90deg, #1a2a4f, #0f3d3e)",
          padding: "0.5rem 1rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#0" role="button">
              <i className="fas fa-bars" style={{ color: "#f5f5dc", fontSize: 18 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#0">
              <b style={{ color: "#fdf6e3", textTransform: "uppercase", fontSize: 16 }}>
                TTXPLORE
              </b>
            </a>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto" style={{ marginLeft: "auto" }}>
          <li className="nav-item">
            <a className="nav-link" href="javascript:history.go(-1)" title="Go Back">
              <i className="fas fa-backward" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="javascript:history.go(+1)" title="Go Forward">
              <i className="fas fa-forward" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" onClick={signOut} href="#0" title="Sign Out">
              <i className="fa fa-sign-out" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
        </ul>
      </nav>

      <style>{`
        .navbar-nav .nav-link:hover {
          color: #d4af37 !important;
          transition: all 0.3s ease;
        }
        .navbar-nav .nav-item {
          margin-left: 0.5rem;
        }
        @media (max-width: 768px) {
          .main-header .navbar-nav {
            flex-wrap: wrap;
          }
        }
      `}</style>
    </div>
  );
}

export default Header;
